import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import AddLawDocs from '../../../components/addLawDocs'
import './style.scss'
const AddLawDocsPage = () => {
    const [readMore, setReadMore] = React.useState(true);
    return (
        <Fragment>
            
           <AddLawDocs
           className="SignInArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default AddLawDocsPage
/* UpdateLawDocs */